import React, { FC, Fragment } from 'react';
import { Button, IconButton, Menu, MenuItem } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import ListAltIcon from '@material-ui/icons/ListAlt';
import { Promotion } from 'kiolyn-api';
import { LayoutVariant } from '../../Core/CommonTypes';

const useStyles = makeStyles(() => ({
  menuItem: {
    cursor: 'auto'
  }
}));

interface PromotionListProps {
  variant?: LayoutVariant;
  promotions: Promotion[];
}

const PromotionList: FC<PromotionListProps> = ({
  variant,
  promotions
}: PromotionListProps) => {
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = React.useState<undefined | HTMLElement>(
    undefined
  );

  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(undefined);
  };

  return (
    <Fragment>
      {variant === LayoutVariant.mobile ? (
        <IconButton
          color="inherit"
          aria-label="show promotions"
          onClick={handleOpen}
        >
          <ListAltIcon />
        </IconButton>
      ) : (
        <Button color="inherit" onMouseEnter={handleOpen}>
          Current Promotions
        </Button>
      )}
      <Menu
        anchorEl={anchorEl}
        open={anchorEl !== undefined}
        onClose={handleClose}
        MenuListProps={{
          onMouseLeave: () => handleClose()
        }}
      >
        {promotions.map(promotion => (
          <MenuItem key={promotion.id} className={classes.menuItem}>
            {promotion.name}
          </MenuItem>
        ))}
      </Menu>
    </Fragment>
  );
};

export default PromotionList;
